module.exports = __webpack_public_path__ + "static/media/send.dc8b9212.svg";